"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateIndexes = void 0;
function generateIndexes(tracks) {
    return tracks.map((track, index) => {
        const indexedTrack = Object.assign(track, { index });
        return indexedTrack;
    });
}
exports.generateIndexes = generateIndexes;
